import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ContactPage.css";
import { Helmet } from "react-helmet-async";
import { useApi } from "../utils/Api";

function ContactPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isMapLoading, setIsMapLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const { apiFetch } = useApi();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, message } = formData;
    setIsLoading(true);

    try {
      const result = await apiFetch("send-contact", {
        name,
        email,
        message,
      });

      if (result.success) {
        navigate("/thank-you");
      } else {
        alert(
          "There was an error sending your message. Please make sure all fields are correct"
        );
      }
    } catch (error) {
      alert("An unexpected error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // Your existing form spinner
  const SpinnerOverlay = () => (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );

  // New spinner for the map only
  const MapSpinner = () => (
    <div className="map-spinner-overlay">
      <div className="map-spinner"></div>
    </div>
  );

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact | LasGidi Restaurant</title>
        <meta
          name="description"
          content="Get in touch with LasGidi Restaurant in Manchester. Find our location, call us, or send a message for bookings and inquiries."
        />
        <meta
          name="keywords"
          content="LasGidi Restaurant, Contact, Manchester Restaurant, Bookings, Inquiries, Nigerian Cuisine"
        />
        <meta property="og:title" content="Contact | LasGidi Restaurant" />
        <meta
          property="og:description"
          content="Get in touch with LasGidi Restaurant in Manchester. Find our location, call us, or send a message for bookings and inquiries."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div
        className="map"
        style={{
          width: "88%",
          height: "500px",
          margin: "auto",
          padding: "20px 0",
          position: "relative",
          boxShadow: "rgba(255, 255, 255, 0.15) 0px 12px 36px 0px",
        }}
      >
        {isMapLoading && <MapSpinner />}
        <iframe
          title="What3Words Map"
          src="https://what3words.com/palace.piper.dame"
          width="100%"
          height="100%"
          style={{ border: "0" }}
          allowFullScreen
          loading="lazy"
          onLoad={() => setIsMapLoading(false)}
        ></iframe>
      </div>

      {isLoading && <SpinnerOverlay />}

      <div className="contactus-container">
        <div className="contactus-boxes">
          <div className="contactus-box">
            <div className="contactus-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <div className="contactus-text">
              <h3>Address</h3>
              <p>
                34, Wellington Road, <br />
                Eccles M30 0NP
              </p>
            </div>
          </div>

          <div className="contactus-box">
            <div className="contactus-icon">
              <i className="fas fa-phone-alt"></i>
            </div>
            <div className="contactus-text">
              <h3>Call</h3>
              <p>
                <a href="tel:01615660344"> 0161 566 0344</a>
              </p>
            </div>
          </div>

          <div className="contactus-box">
            <div className="contactus-icon">
              <i className="far fa-envelope"></i>
            </div>
            <div className="contactus-text">
              <h3>E-mail</h3>
              <p>
                <a href="mailto:restaurantlasgidi@gmail.com">
                  restaurantlasgidi@gmail.com
                </a>
              </p>
            </div>
          </div>

          <div className="contactus-box">
            <div className="contactus-icon">
              <i className="far fa-clock"></i>
            </div>
            <div className="contactus-text">
              <h3>Opening Hours</h3>
              <p>Monday - Saturday & Bank Holidays: 1pm - 10pm</p>
              <p>Sunday: 2pm - 6:30pm</p>
            </div>
          </div>
        </div>

        <div className="form section-animated" id="message-form">
          <div className="contactus-form">
            <h3>Send us a message</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Name"
                  required
                  autoComplete="off"
                  value={formData.name}
                  onChange={handleChange}
                />
                <label htmlFor="name">Name</label>
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email Address"
                  required
                  autoComplete="off"
                  value={formData.email}
                  onChange={handleChange}
                />
                <label htmlFor="email">Email Address</label>
              </div>

              <div className="form-group">
                <textarea
                  rows="8"
                  name="message"
                  id="message"
                  placeholder="Message"
                  required
                  autoComplete="off"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                <label htmlFor="message">Message</label>
              </div>

              <button
                type="submit"
                className="submit-btn cta-button primary-btn post-review-btn"
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
